import { Button, ButtonProps, Typography, TypographyProps } from "@mui/material";
import styles from "./EditQuizButton.module.css";
import { useState } from "react";
import { CoreExpandIcon } from "../../core";

type EditQuizExpandButtonProps = {
	children: React.ReactNode;
	onClick?: () => void;
	icon?: React.ReactNode;
	title?: React.ReactNode;
	description?: React.ReactNode;

	// maybe this should be a controlled component?
	defaultOpen?: boolean;
	slotProps?: {
		title?: TypographyProps;
		description?: TypographyProps;
	};
} & Omit<ButtonProps, "children">;

// Maybe this should be a core component...?
export function EditQuizExpandButton({
	children,
	icon,
	title,
	description,
	slotProps,
	defaultOpen = false,
	onClick,
	...props
}: EditQuizExpandButtonProps) {
	const titleProps = slotProps?.title;
	const descProps = slotProps?.description;
	const [expanded, setExpanded] = useState<boolean>(defaultOpen);

	const handleExpand = () => {
		setExpanded(!expanded);
		onClick?.();
	};

	return (
		<div className={styles.collapseContainer}>
			<Button className={styles.editQuizExpandButton} aria-expanded={expanded} onClick={handleExpand} {...props}>
				<div className={styles.summaryWrapper}>
					{icon}
					<div className={styles.titleWrapper}>
						{typeof title === "string" ? (
							<Typography className={styles.title} {...titleProps}>
								{title}
							</Typography>
						) : (
							title
						)}
						{typeof description === "string" ? (
							<Typography className={styles.description} {...descProps}>
								{description}
							</Typography>
						) : (
							description
						)}
					</div>
				</div>
				{/**Accessibility says no clickables in clickables. */}
				<CoreExpandIcon expanded={expanded} size={14} />
			</Button>
			{expanded && <div className={styles.expandedContent}>{children}</div>}
		</div>
	);
}

type EditQuizViewMoreButtonProps = {
	text: string;
	onClick: () => void;
	className?: string;
	expanded?: boolean;
};

export function EditQuizViewMoreButton({ onClick, text, className, expanded }: EditQuizViewMoreButtonProps) {
	return (
		<Button onClick={onClick} className={`${styles.viewMoreButton} ${className || ""}`}>
			<Typography className={styles.viewMoreText}>{text}</Typography>
			<CoreExpandIcon expanded={expanded ?? false} size={10} color="#874bd3" />
		</Button>
	);
}
